import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Item = styled(Link)<{ image: string }>`
  background: ${({ image, theme }) => (image ? `url(${image})` : `${theme.menuBackgroundColor}`)};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 168px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  animation: fade-in 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
  border-radius: 4px;

  @media (min-width: 768px) {
    transition: transform 0.1s ease-in-out;

    &:hover {
      transform: scale(0.99);
    }
  }
`;
const Title = styled.h2<{ fontSize: number; lineHeight: number; hasImage: boolean }>`
  color: ${({ hasImage, theme }) => (hasImage ? 'rgb(255, 255, 255)' : `${theme.menuTextColor}`)};
  font-size: ${(props) => `${props.fontSize}px`};
  font-weight: 600;
  line-height: ${(props) => `${props.lineHeight}px`};
  text-align: center;
`;

type Props = {
  id: string;
  image: string;
  name: string;
  venueId: string;
  isGrid?: boolean;
};

const maxGridCharacters = 11;
const smallFontSize = 16;
const smallLineHeight = 22;
const defaultFontSize = 24;
const defaultLineHeight = 32;

const MenuItem = ({ id, image, name, venueId, isGrid }: Props) => {
  const fontStyle = useMemo(() => {
    if (isGrid) {
      const numberOfCharacters = name.length;
      if (numberOfCharacters > maxGridCharacters) {
        return { fontSize: smallFontSize, lineHeight: smallLineHeight };
      }
    }
    return { fontSize: defaultFontSize, lineHeight: defaultLineHeight };
  }, [isGrid]);

  return (
    <Item to={`/order/${venueId}/menu/${id}`} image={image}>
      <Title fontSize={fontStyle.fontSize} lineHeight={fontStyle.lineHeight} hasImage={!!image}>
        {name}
      </Title>
    </Item>
  );
};

export default MenuItem;
